import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Slide, Swiper } from 'react-dynamic-swiper';
import styles from './slideshow.scss';

class Slideshow extends PureComponent {
  render() {
    const { className, items, options, componentid } = this.props;
    return (
      <Swiper
        className={
          className ? `${styles.slideshow} ${className}` : styles.slideshow
        }
        swiperOptions={options}
        pagination={false}
        nextButton={<span id={`next-${componentid}`}></span>}
        prevButton={<span id={`prev-${componentid}`}></span>}
      >
        {items.map((item) => {
          return <Slide key={item.itemKey}>{item.component}</Slide>;
        })}
      </Swiper>
    );
  }
}

Slideshow.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array,
  options: PropTypes.object,
  componentid: PropTypes.string,
};

export default Slideshow;
